import React from "react";
import { Col, Row } from "react-bootstrap";
import useInViewOnce from "../../hooks/useInViewOnce";

import shiftup2 from "../../Assets/Projects/shiftup2.gif";
import travis_county from "../../Assets/Projects/Travis_County.png";
import austin_city from "../../Assets/Projects/Austin_City.png";
import san_marcos from "../../Assets/Projects/San_Marcos_Library.png";
import crimson_ark from "../../Assets/Projects/crimson_ark.png";
import urban_alchemy from "../../Assets/Projects/Urban-Alchemy.jpg"
import code_soil from "../../Assets/Projects/code&soil.png"
import montopolis from "../../Assets/Projects/Montopolis.jpg"
import unrulr from "../../Assets/Projects/Unrulr.png"
import insight from "../../Assets/Projects/Insight.png"
import mido from "../../Assets/Projects/Mido.png"
import techkids from "../../Assets/Projects/TechKidsUltd.png"
import ldg from "../../Assets/Projects/LDG.png"
import centro from "../../Assets/Projects/Centro.png"
import assist from "../../Assets/Projects/Assist.png"
import favrhood from "../../Assets/Projects/favrhood_logo1.png"

function Toolstack() {
  const { ref: partnersRef, hasEntered: partnersSeen } = useInViewOnce({ threshold: 0.18, once: true });

  const partners = [
    { img: travis_county, alt: "Travis County" },
    { img: austin_city, alt: "Austin City" },
    { img: shiftup2, alt: "ShiftUp" },
    { img: san_marcos, alt: "San Marcos Library" },
    { img: crimson_ark, alt: "Crimson Ark Studio", label: "Crimson Ark Studio" },
    { img: favrhood, alt: "Favrhood" },
    { img: urban_alchemy, alt: "Urban Alchemy" },
    { img: code_soil, alt: "Code & Soil" },
    { img: montopolis, alt: "Montopolis" },
    { img: unrulr, alt: "Unrulr" },
    { img: insight, alt: "Insight" },
    { img: mido, alt: "Mido" },
    { img: techkids, alt: "TechKidsUltd" },
    { img: ldg, alt: "LDG" },
    { img: centro, alt: "Centro" },
    { img: assist, alt: "Assist" },
  ];

  return (
    <Row ref={partnersRef} style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {partners.map((partner, index) => (
        <Col
          key={partner.alt}
          xs={4}
          md={2}
          className={`tech-icons cf-reveal${partnersSeen ? " is-seen" : ""}`}
          style={{ animationDelay: `${index * 65}ms` }}
        >
          {partner.label ? <span>{partner.label}</span> : null}
          <img src={partner.img} alt={partner.alt} className="img-fluid" />
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
